import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table";
import { selectForumTopicsListItems } from "../../../../../../redux/forum-topics/selector";
import { forumTopics } from "../../../../../../redux/forum-topics/action";


const ForumTopics = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);

  const ForumTopicsItems = useSelector(selectForumTopicsListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },

      {
        field: 'ForumId', headerName: 'Forum', searchField: 'ForumId', filter: true,
        filterType: 'text'
      },
      { field: 'TopicTypeId', headerName: 'TopicType' },
      { field: 'Subject', headerName: 'Subject' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true },



    ]);
  }


  const handleSearch = (data: any) => {

    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "ForumId",
        FieldText: "ForumId",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }

    dispatch(forumTopics.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/forum-topics/list`, entity: 'forumTopics', jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }))
  }



  const handleReloadData = () => {
    dispatch(forumTopics.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/forum-topics/list`, entity: 'forumTopics', jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",


      }
    }))
  }
  const filterTypes = [{
    name: 'Text', value: "text"
  },
  {
    name: 'Number', value: "number"
  },
  {
    name: 'CheckBox', value: "checkbox"
  },
  {
    name: 'Date', value: "date"
  }
  ]
  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }

  const fetchForumTopics = () => {
    dispatch(forumTopics.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/forum-topics/list`, entity: 'forumTopics', jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",


      }
    }))
  }
  const handleAdd = () => {
    navigate(`${0}`);
  };

  const additionButtons: any = [

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Forum Topics</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,

      callback: () => handleReloadData(),
    },
  ];
  useEffect(() => {
    createColumnDefs()
    fetchForumTopics()
  }, [pageData, pageSize])
  const handleDelete = (data: any) => {
    dispatch(forumTopics.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/forum-topics/delete`,
      entity: 'forumTopics',
      jsonData: {
        Context: {},

        Records: [
          {

            Id: data?.Id
          }

        ]
      }
    })).then(() => {
      dispatch(forumTopics.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/forum-topics/list`, entity: 'forumTopics', jsonData: {

          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",


        }
      }))
    });
  }
  return (
    <>
      {ForumTopicsItems?.isLoading ? <PageLoader /> :
        <Table enableFilter={true}
          filterTypeLists={filterTypes}
          onSearch={handleSearch} columnData={columnDefs} rowData={ForumTopicsItems?.result?.items} setPageData={setPageData}
          setPageSize={setPageSize} paginationData={ForumTopicsItems?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} onDelete={handleDelete} headingName="Forum Topics" />

      }
    </>
  );
};

export default ForumTopics;